// extracted by mini-css-extract-plugin
export default {"heading":"ModalSkeleton_heading__pAJXR"};